<script>
  import { emitter } from '@/main.js';
  import { augmentHistoryReplaceState, handleViewportSize } from '@/lib/vue-helpers.js';
  export default {
    name: 'CollectionFilterButtons',
    mounted() {
      this.handleViewportSize = handleViewportSize(this);
      // Set up the monkey patch for history.replaceState to dispatch 'replacestate' events
      augmentHistoryReplaceState();

      this.narrowBy = this.getCurrentFilters();
      this.glassEnabled = this.resolveGlassEnabled();
      window.addEventListener('replacestate', this.syncStateFromUrl);
      document.addEventListener('theme:plp-glass:change', this.onGlassChange);

      emitter.on('fs-update', e => {
        this.avoidList = e.avoidPrefixList;
        this.totalResults = e.totalResults;
        this.shownProducts = e.products.length;
      });
    },
    beforeUnmount() {
      if (this.handleViewportSize) this.handleViewportSize();
      window.removeEventListener('replacestate', this.syncStateFromUrl);
      document.removeEventListener('theme:plp-glass:change', this.onGlassChange);
      emitter.off('fs-update');
    },
    data() {
      return {
        avoidList: [],
        narrowBy: [],
        totalResults: 0,
        shownProducts: 0,
        glassEnabled: false
      };
    },
    computed: {
      crumbCap() {
        return this.glassEnabled ? 15 : 5;
      }
    },
    methods: {
      resolveGlassEnabled() {
        // Prefer the JS flag, but fall back to the server-rendered gate class since
        // window.theme can be reassigned by the main theme config, dropping the flag.
        if (window.theme && typeof window.theme.plpGlassEnabled === 'boolean') return window.theme.plpGlassEnabled;
        return document.documentElement.classList.contains('plp-glass-on');
      },
      onGlassChange(e) {
        this.glassEnabled = !!(e && e.detail && e.detail.enabled);
      },
      syncStateFromUrl() {
        this.narrowBy = this.getCurrentFilters();
      },
      getUrlParam(param) {
        const url = new URL(window.location.href);
        return url.searchParams.get(param);
      },
      getCurrentFilters() {
        let filters = this.getUrlParam('filters');
        if (filters) {
          return JSON.parse(decodeURIComponent(filters));
        }
        return [];
      },
      updateNarrowButtons(value) {
        let currentFilters = this.getCurrentFilters();
        const newFilters = currentFilters.filter(item => {
          return item[1] !== value;
        });
        this.setUrlParam('filters', newFilters);

        // Update narrowBy immediately
        this.narrowBy = this.getCurrentFilters();
        emitter.emit('fs-update-filter', newFilters);
      },
      setUrlParam(paramName, paramValue) {
        const url = new URL(window.location.href);
        url.searchParams.set(paramName, JSON.stringify(paramValue));
        window.history.replaceState(null, null, url);
      },
      cleanPillText(filterKey, text) {
        let cleanedText = text;
        if (this.avoidList) {
          this.avoidList.forEach(avoid => {
            const cleanAvoid = avoid.replace('*', '');
            if (cleanedText) {
              if (cleanedText.startsWith(cleanAvoid)) {
                cleanedText = cleanedText.replace(cleanAvoid, '');
              }
            }
          });
        }

        if (filterKey === 'Price_from_to') {
          const rangePattern = /^(\d+)-(\d+)$/;
          const match = cleanedText.match(rangePattern);
          if (match) {
            return `$${match[1]}-$${match[2]}`;
          }
        }
        return cleanedText;
      }
    }
  };
</script>

<template>
  <div class="collection__active__filters__wrapper" v-if="narrowBy && narrowBy.length > 0">
    <div class="collection__active__filters">
      <a class="active__filters__remove gt-p__small" v-for="(filter, index) in narrowBy.slice(0, crumbCap).reverse()" :key="'facet-buttons-' + index" @click.prevent="updateNarrowButtons(filter[1])">
        <span v-html="cleanPillText(filter[0], filter[1])"></span>
        <span class="filter__x">X</span>
      </a>
    </div>
    <div class="collection__count" data-products-count="" v-if="totalResults" style="display: none"><strong v-html="shownProducts"></strong> of <strong v-html="totalResults"></strong> products</div>
  </div>
</template>

<style lang="scss">
  #fs-collection-filter-buttons {
   &.is-mobile {
      display: none;
    }
    .active__filters__remove {
      cursor: pointer;
      span {
        text-transform: capitalize;
      }
    }
  }

  .filter__button label {
    text-transform: capitalize !important;
  }

  .filter-button-wrapper {
    margin-left: 8px;
    overflow: hidden;

    .is-mobile & {
      display: none;
    }
  }

  .collection__active__filters__wrapper {
    margin-top: 0;
    padding-bottom: 0;
  }
</style>
